// Imports => Vendor
import axios from 'axios';

// Imports => Interceptors
import { AcTokenRefresher } from './interceptors.api';

// Imports => API
import AuthAPI from '@api/auth.api';
import FaqAPI from '@api/faq.api';
import FilesAPI from '@api/files.api';
import KpisAPI from '@api/kpis.api';
import NewsAPI from '@api/news.api';
import ProfileAPI from '@api/profile.api';
import ProjectsAPI from '@api/projects.api';
import ProjectUpdatesAPI from '@api/project-updates.api';

const onUploadProgress = (event) => {
	console.group('[Axios] => fn.onUploadProgress');
	console.log('Event: ', event);
	console.groupEnd();
};

const onDownloadProgress = (event) => {
	console.group('[Axios] => fn.onDownloadProgress');
	console.log('Event: ', event);
	console.groupEnd();
};

let _timeOut = null;
let _errorControllers = [];

const unauthenticatedState = (state) => {
	const unauthenticatedEvent = new CustomEvent('unAuthenticate');
	window.dispatchEvent(unauthenticatedEvent);
};

const cancelRequests = () => {
	const collection = _errorControllers;
	const len = collection.length;
	let n = 0;

	for (n; n < len; n++) {
		const instance = collection[n];
		if (instance?.abort) instance.abort();
	}

	_errorControllers = [];
};

const addInterceptors = (requestClient) => {
	requestClient.interceptors.response.use(
		(response) => {
			return response;
		},

		(error) => {
			const originalRequest = error.config;

			if (error.response && error.response.status === 401) {
				console.group('Response Interceptor');
				console.log('_isRefreshing', _isRefreshing);
				console.log('_refreshAndRetryQueue', _refreshAndRetryQueue);
				console.group('Error');
				console.log('error', error);
				console.log('error.response', error.response);
				console.groupEnd();
				console.groupEnd();

				if (_isRefreshing) {
					return new Promise((resolve, reject) => {
						_refreshAndRetryQueue.push({
							config: originalRequest,
							resolve,
							reject,
						});
					});
				}

				// Add the original request to the queue if a refresh is in progress
				if (!_isRefreshing) {
					_isRefreshing = true;
					// Refresh the access token
					// Refresh with last param 'force' as true
					return AcTokenRefresher(requestClient, unauthenticatedState, true)
						.then(async () => {
							console.log(
								'originalRequest',
								originalRequest.headers['Authorization']
							);

							if (AcIsSet(requestClient?.headers?.['Authorization'])) {
								const freshAccessToken = AcGetState(KEYS.ACCESS_TOKEN);
								requestClient.headers[
									'Authorization'
								] = `Bearer ${freshAccessToken}`;
							}

							// Retry all requests in the queue with the new token
							await _refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
								return requestClient
									.request(config)
									.then((response) => resolve(response))
									.catch((err) => reject(err));
							});

							// Clear the queue
							_refreshAndRetryQueue = [];

							// Retry the original request
							return requestClient(originalRequest);
						})
						.catch((refreshError) => {
							const cancelRequestsEvent = new CustomEvent('cancelRequests');
							window.dispatchEvent(cancelRequestsEvent);

							// Handle token refresh error
							// You can clear all storage and redirect the user to the login page
							throw refreshError;
						})
						.finally(() => {
							_isRefreshing = false;
						});
				}
			}

			// Return a Promise rejection if the status code is not 401
			return Promise.reject(error);
		}

		// async (error) => {
		//   if (error.response && error.response.status === 401) {
		//     clearTimeout(_timeOut);

		//     const cancelRequestsEvent = new CustomEvent('cancelRequests');
		//     window.dispatchEvent(cancelRequestsEvent);

		//     _timeOut = setTimeout(() => unauthenticatedState(false), 500);
		//   }
		//   return Promise.reject(error);
		// }
	);
};

export class API {
	constructor(config, Store) {
		this.Store = Store;

		const Client = axios.create({
			...config.api,
		});
		addInterceptors(Client);

		const DownloadClient = axios.create({
			...config.download,
			onDownloadProgress,
		});
		addInterceptors(DownloadClient);

		const UploadClient = axios.create({
			...config.upload,
			onUploadProgress,
		});
		addInterceptors(UploadClient);

		window.addEventListener('cancelRequests', cancelRequests, false);

		this.auth = new AuthAPI({ Store, Client });
		this.faq = new FaqAPI({ Store, Client });
		this.files = new FilesAPI({ Store, Client, DownloadClient });
		this.kpis = new KpisAPI({ Store, Client });
		this.news = new NewsAPI({ Store, Client });
		this.profile = new ProfileAPI({ Store, Client });
		this.projects = new ProjectsAPI({ Store, Client });
		this.project_updates = new ProjectUpdatesAPI({ Store, Client, DownloadClient });
	}
}

export default API;
